module.exports = __webpack_public_path__ + "img/4PILOT.585beb43.jpg";